/* "What are fringes?" link under the fringe dropdown, opens a small popup with ONE sample photo.
   10-05 Harsh: one sample image just for the idea, it does not need to match the product.
   Harsh picked idea 4 on 10-04. Finds the theme's own option block, so it only shows on products
   that have a "Do You need Fringes?" option. Photo URL comes from window.ZR_FRINGE_IMG.sample. */
(function () {
  var IMG = window.ZR_FRINGE_IMG || {};
  var TEXT = 'Fringes are the short tassels on the two short ends of the rug. Choose No if you want the rug without them.';

  function css() {
    if (document.getElementById('zr-fr-css')) return;
    var s = document.createElement('style');
    s.id = 'zr-fr-css';
    s.textContent =
      '.zr-fr-link{display:block;background:none;border:0;padding:0;margin:10px 0 0;height:auto;min-height:0;min-width:0;' +
      'font:inherit;font-size:15px;line-height:1.4;color:inherit;text-decoration:underline;text-underline-offset:3px;cursor:pointer;box-shadow:none}' +
      '.zr-fr-bg{display:none;position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:2147483000;align-items:center;justify-content:center;padding:16px}' +
      '.zr-fr-bg.is-open{display:flex}' +
      '.zr-fr-box{background:#fff;color:#111;border-radius:12px;max-width:440px;width:100%;padding:20px;position:relative;font:inherit}' +
      '.zr-fr-box h3{margin:0 32px 6px 0;font-size:19px;font-weight:600;line-height:1.3}' +
      '.zr-fr-box p{margin:0 0 4px;font-size:15px;line-height:1.5}' +
      '.zr-fr-x{position:absolute;top:10px;right:12px;border:0;background:none;padding:4px;font-size:24px;line-height:1;cursor:pointer;color:#111;min-height:0;height:auto}' +
      '.zr-fr-one{margin:12px 0 0}' +
      '.zr-fr-one img{width:100%;height:auto;border-radius:8px;display:block}' +
      '.zr-fr-one figcaption{font-size:14px;text-align:center;margin-top:6px;color:#555}';
    document.head.appendChild(s);
  }

  function modal() {
    var bg = document.getElementById('zr-fr-modal');
    if (bg) return bg;
    bg = document.createElement('div');
    bg.id = 'zr-fr-modal';
    bg.className = 'zr-fr-bg';
    bg.setAttribute('role', 'dialog');
    bg.setAttribute('aria-modal', 'true');
    bg.setAttribute('aria-labelledby', 'zr-fr-title');
    bg.innerHTML =
      '<div class="zr-fr-box"><button type="button" class="zr-fr-x" aria-label="Close">&times;</button>' +
      '<h3 id="zr-fr-title">What are fringes?</h3><p>' + TEXT + '</p>' +
      '<figure class="zr-fr-one"><img src="' + (IMG.sample || '') + '" alt="Corner of a rug with short fringe tassels along the end" loading="lazy">' +
      '<figcaption>Example of a rug with fringe</figcaption></figure></div>';
    bg.addEventListener('click', function (e) {
      if (e.target === bg || e.target.classList.contains('zr-fr-x')) close();
    });
    document.body.appendChild(bg);
    return bg;
  }

  var opener = null;
  function open(e) {
    opener = e.currentTarget;
    var bg = modal();
    bg.classList.add('is-open');
    bg.querySelector('.zr-fr-x').focus();
  }
  function close() {
    var bg = document.getElementById('zr-fr-modal');
    if (!bg || !bg.classList.contains('is-open')) return;
    bg.classList.remove('is-open');
    if (opener) opener.focus();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function add() {
    var blocks = document.querySelectorAll('variant-select[data-option-name]');
    for (var i = 0; i < blocks.length; i++) {
      var el = blocks[i];
      if (!/fringe/i.test(el.getAttribute('data-option-name')) || el.querySelector('.zr-fr-link')) continue;
      var anchor = el.querySelector('.m-product-option--content');
      if (!anchor) continue;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'zr-fr-link';
      b.textContent = 'What are fringes?';
      b.addEventListener('click', open);
      anchor.insertAdjacentElement('afterend', b);
    }
  }

  function start() {
    css();
    add();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; add(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
